export default "__VITE_ASSET__BCOPSsdx__"